import { render, staticRenderFns } from "./editShippingTemplate.vue?vue&type=template&id=3cafeef3&scoped=true&"
import script from "./editShippingTemplate.vue?vue&type=script&lang=ts&"
export * from "./editShippingTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./editShippingTemplate.vue?vue&type=style&index=0&id=3cafeef3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cafeef3",
  null
  
)

export default component.exports